// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_26ivU","inner":"style_inner_SXKor"};